import React, { useEffect, useState } from 'react';
import { login } from '../../utils';
import { useHistory, useLocation } from 'react-router';
import { useAuthContext } from '../../contexts/Auth';
import { useOnboardingContext } from '../../contexts/Onboarding';
import { Auth } from 'aws-amplify';
import Layout from '../../components/auth/ResetPassword';

export default function ResetPassword() {
  const history = useHistory();
  const location = useLocation();
  const { signedIn, signIn } = useAuthContext();
  const [user, setUser] = useState(null);
  const [code, setCode] = useState(null);
  const [error, setError] = useState(null);
  const { setHasCompletedOnboarding, setActiveStep } = useOnboardingContext();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setCode(params.get('code'));
    setUser(params.get('user'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return signedIn ? (
    <div />
  ) : (
    <Layout
      error={error}
      onSubmit={async (password) => {
        try {
          await Auth.forgotPasswordSubmit(user, code, password);
          await login({
            email: user,
            password,
            signIn,
            history,
            setUser,
            setHasCompletedOnboarding,
            setActiveStep,
          });
        } catch (error) {
          setError(error.message);
        }
      }}
    />
  );
}
